import { configureStore } from '@reduxjs/toolkit';
import dataReducer from './dataSlice';
import chatReducer from './chatSlice';

export const store = configureStore({
    reducer: {
        data: dataReducer,
        chat: chatReducer,
    },
});
